import request from "@/utils/request";
import { formDataHeaders, jsonHeaders, headers } from "./api-header-conf.js";

export function sendCodeMsg(data) {
  return request({
    headers: formDataHeaders,
    url: "/custom/codeMsg",
    method: "post",
    data
  });
}
export function verifyMsg(data) {
  return request({
    headers: formDataHeaders,
    url: "/custom/verifyMsg",
    method: "post",
    data
  });
}
export function resgister(data) {
  return request({
    jsonHeaders,
    url: "/wxuser/add",
    method: "post",
    data
  });
}
export function resgisterYGHDB(data) {
  return request({
    jsonHeaders,
    url: "/wxuser/add/YGHDB",
    method: "post",
    data
  });
}
//代扣银海开户行列表
export function getBankList() {
  return request({
    headers,
    url: "/bank/list",
    method: "GET"
  });
}
//代扣绑定验证码
export function getDKYzm(data) {
  return request({
    jsonHeaders,
    url: "/fastPay/message",
    method: "POST",
    data
  });
}

export function verifyDKYzm(data) {
  return request({
    jsonHeaders,
    url: "/fastPay/verifyMsg",
    method: "POST",
    data
  });
}
